<template>
  <div>
    <data-config v-if="id === 'data-config'" />
  </div>
</template>

<script>
import DataConfig from './DataConfig.vue';

export default {
  name: 'AdminWindow',
  components: {
    DataConfig,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
};
</script>
